<template>
    <resource-form :model="form.model"
        :schema="form.schema"
        :triggers="form.triggers"
        :no-form-group="true"
        @submit="onFormSubmit">
        <button type="button" slot="cancel" class="btn btn-default btn-sm" @click="onCancelButtonClick">
            Annuler
        </button>
    </resource-form>
</template>

<script>
    import ResourceForm from "components/Forms/ResourceForm"

    export default {
        data() {
            return {
                form: {
                    model: {
                        "phone": this.user.phone
                    },
                    schema: {
                        fields: [
                            {
                                "type": "text",
                                "label": "Téléphone",
                                "model": "phone",
                                "readonly": false,
                                "placeholder": "",
                                "disabled": false,
                                "hidden": false,
                                "help": "",
                                "hint": "",
                                "required": false
                            }
                        ],
                        optional_fields: []
                    },
                    triggers: {}
                }
            }
        },

        props: {
            user: {
                required: true
            }
        },

        components: {
            ResourceForm
        },

        methods: {
            updateUserPhone(payload) {
                return this.$root.axios.put(`users/${this.user.id}/update_phone`, payload)
            },

            onFormSubmit({ data: model }) {
                this.updateUserPhone(model)
                    .then(() => {
                        this.$emit('phone-updated')
                
                        // For modal handling
                        this.$parent.$emit('modal-closed')
                    })
            },

            onCancelButtonClick() {
                this.$emit('operation-canceled')
                
                // For modal handling
                this.$parent.$emit('modal-closed')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// client/components/Users/UserPhoneUpdateForm.vue